var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.load)?_c('Loading'):_vm._e(),(_vm.activated)?_c('div',{attrs:{"id":_vm.nameApp}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }